export function getVisibleUsedMedications<T extends { isDefault?: boolean }>(
    usedMedications: T[],
    forceFiltering?: boolean,
): T[] {
    const realMedications = usedMedications.filter(medication => !medication.isDefault);

    if (forceFiltering || realMedications.length > 0) {
        return realMedications;
    }

    return usedMedications;
}
